export default {
  AUTH_TOKEN: 'AUTH_TOKEN_ADVEASY_LAWYER_WEB',
};
